import { __assign, __extends } from "tslib";
import * as React from 'react';
import { createTranslateFn, testDataCreator } from '../..';
var DummyClass = /** @class */ (function () {
    function DummyClass() {
    }
    return DummyClass;
}());
// this is a hack so lack of react doesn't cause this file to explode in runtime
var Comp = React.PureComponent || DummyClass;
var BaseAnsComp = /** @class */ (function (_super) {
    __extends(BaseAnsComp, _super);
    function BaseAnsComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseAnsComp;
}(Comp));
export { BaseAnsComp };
var ViewComp = /** @class */ (function (_super) {
    __extends(ViewComp, _super);
    function ViewComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ViewComp;
}(BaseAnsComp));
export { ViewComp };
export var testViewCompPropsCreator = function (defaultsOrFn, tSource) {
    if (tSource === void 0) { tSource = {}; }
    var t = createTranslateFn(function (k) { return tSource[k]; });
    var defaults = typeof defaultsOrFn === 'function' ? defaultsOrFn() : defaultsOrFn;
    return testDataCreator(function () { return (__assign({ t: t }, defaults)); });
};
var AnsViewComp = /** @class */ (function (_super) {
    __extends(AnsViewComp, _super);
    function AnsViewComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AnsViewComp;
}(ViewComp));
export { AnsViewComp };
//# sourceMappingURL=index.js.map